import R from 'ramda'
import {
  ACTIONS
} from '../constants'

import {
  isNilOrEmpty
} from '../utils'

const actionIs = R.pathEq(['action', 'type'])

const actCondition = (path, method) => {
  const action = R.path(path, ACTIONS)
  return isNilOrEmpty(action)
    ? null
    : [actionIs(action), method]
}

const baseRequest = ({state, action}) => {
  const statePath = R.prop('statePath', action)
  if (isNilOrEmpty(statePath)) {
    return state
  }
  const request = {
    isLoading: action._id || true,
    progress: 0,
    error: null
  }
  const reqestPath = R.concat(statePath, ['request'])
  return R.assocPath(reqestPath, request, state)
}

const baseFailure = ({state, action}) => {
  const statePath = R.prop('statePath', action)
  if (isNilOrEmpty(statePath)) return state
  const error = R.pathOr('unknown error', ['body', 'error'], action)
  const request = {
    isLoading: false,
    progress: 0,
    error
  }
  const reqestPath = R.concat(statePath, ['request'])
  return R.assocPath(reqestPath, request, state)
}

const baseProgress = ({state, action}) => {
  const statePath = R.prop('statePath', action)
  if (isNilOrEmpty(statePath)) return state
  const progress = R.path(['event', 'percent'], action)
  // no need to update unless we get the percent  in the event
  // for GET the event first fills with e.upload, then e.download, then e.perecent
  // we don't need to do any updates for the first two
  if (isNilOrEmpty(progress)) return state

  const progressPath = R.concat(statePath, ['request', 'progress'])
  return R.assocPath(progressPath, progress, state)
}

const modifySuccess = ({state, action}) => {
  const statePath = R.prop('statePath', action)
  if (isNilOrEmpty(statePath)) return state

  const institution = R.propOr({}, 'body', action)
  const instPath = R.concat(statePath, ['institution'])
  const request = {
    isLoading: false,
    progress: 0,
    error: null
  }
  const reqestPath = R.concat(statePath, ['request'])
  return R.compose(
    R.assocPath(reqestPath, request),
    R.assocPath(instPath, institution)
  )(state)
}

const reducerList = [
  // REFRESH/GET patch/post/delete on single entities
  actCondition(['FETCH_INSTITUTION', 'REQUEST'], baseRequest),
  actCondition(['FETCH_INSTITUTION', 'PROGRESS'], baseProgress),
  actCondition(['FETCH_INSTITUTION', 'FAILURE'], baseFailure),
  actCondition(['FETCH_INSTITUTION', 'SUCCESS'], modifySuccess)

].filter(x => x)

export default reducerList



// WEBPACK FOOTER //
// ./webAdmin/reducers/thirdParty.js